import React, { useEffect, createRef } from "react";
import styled from "styled-components";

export enum CheckboxStates {
  Unchecked,
  Checked,
  Indeterminate,
}

interface Props {
  state: CheckboxStates;
  readOnly?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  label?: string;
  className?: string;
}

const CheckboxWrapper = styled.label`
  input,
  span {
    user-select: none;
  }
`;

/**
 * A checkbox component that supports an indeterminate state.
 * @param {Props} props
 */
const Checkbox = ({ state, readOnly, onChange, label, className }: Props) => {
  const ref = createRef<HTMLInputElement>();

  useEffect(() => {
    switch (state) {
      case CheckboxStates.Unchecked:
      case CheckboxStates.Checked: {
        ref.current!.checked = state === CheckboxStates.Checked;
        ref.current!.indeterminate = false;
        break;
      }
      case CheckboxStates.Indeterminate: {
        ref.current!.checked = false;
        ref.current!.indeterminate = true;
        break;
      }
      default: {
        throw new Error("Expected a value from CheckboxStates");
      }
    }
  }, [state]);

  const renderInput = () => {
    return (
      <input
        className={className}
        ref={ref}
        type="checkbox"
        onChange={onChange}
        readOnly={readOnly || false}
        disabled={readOnly || false}
      />
    );
  };

  if (label?.length) {
    return (
      <CheckboxWrapper>
        {renderInput()}
        {<span>{label}</span>}
      </CheckboxWrapper>
    );
  } else {
    return renderInput();
  }
};

export default Checkbox;
